import { useTranslation } from 'react-i18next';
import { Loading, Stack, styled, Text } from 'shell/components';

const GradingRegenerating = (props) => {
    const { t } = useTranslation('assignment');

    return (
        <RootStack alignItems={'center'} spacing={8} {...props}>
            <Stack alignItems={'center'} spacing={2}>
                <Text align={'center'} component={'p'} variant={'h6'} weight={'semibold'}>
                    {t('grading-section.regenerated-title', 'Grades are being regenerated')}
                </Text>
                <Text align={'center'}>
                    {t(
                        'grading-section.regenerated-description',
                        'Please keep this window open until this process completes. This may take a few minutes.'
                    )}
                </Text>
            </Stack>
            <Loading sx={{ zoom: 0.5 }} />
            {/* <Button color={'neutral'} variant={'tertiary'}>
                Cancel Regeneration
            </Button> */}
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        position: 'relative',
        top: '40%',
        padding: theme.spacing(0, 5),
    };
});

export default GradingRegenerating;
